<div class="start-container">
	<a (click)="restart()" class="btn start-button">{{ 'retryButton.title' | translate}}</a>	
</div>